<template>
  <div class="json-editor">
    <textarea ref="textarea" />
  </div>
</template>

<script>
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/rubyblue.css';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/lint';

export default {
  name: 'JsonEditor',
  props: {
    value: {
      type: [String, Object, Array],
      default: '',
    },
  },
  data() {
    return {
      jsonEditor: false,
    };
  },
  watch: {    
  },
  mounted() {
    this.jsonEditor = CodeMirror.fromTextArea(this.$refs.textarea, {
      tabSize: 4,
      styleActiveLine: true,
      line: true,
      lineNumbers: true,      
      foldGutter: true,
      styleSelectedText: true,
      matchBrackets: true,
      showCursorWhenSelecting: true,      
      mode: 'text/javascript',
      gutters: ['CodeMirror-lint-markers'],
      theme: 'rubyblue',
      lint: true,
    });
    this.jsonEditor.setValue(this.value);
    this.jsonEditor.on('change', (cm) => {
      this.$emit('changeData', cm.getValue());
    });
  },
  methods: {
    getValue() {
      return this.jsonEditor.getValue();
    },
  },
};
</script>

<style lang="scss">
.json-editor {
  .CodeMirror {
    border: 1px solid #eee;
    height: auto !important;
    min-height: 45px !important;
    // max-height: 500px;
    line-height: 20px;
  }

  .CodeMirror-scroll {
    min-height: 200px;
  }
}
</style>
